var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 42 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1192 -51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse-1",
    fill: "#D73A1F",
    d: "M1213 51c11.6 0 21 9.402 21 21s-9.4 21-21 21-21-9.402-21-21 9.4-21 21-21z"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse-11",
    d: "M1213 51c11.6 0 21 9.402 21 21s-9.4 21-21 21-21-9.402-21-21 9.4-21 21-21z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-1",
    fill: "#F5F5F5",
    fillOpacity: 1,
    d: "M1233 97h-42c.21-2.922 2.31-8.029 4.56-8.948.8-.237 1.61-.474 2.41-.71 2.06-1.243 4.11-2.486 6.17-3.729-.02-.512.03-.864.18-1.154l3.03-.977-.18-.799c-.5-1.124-1.01-2.249-1.52-3.373-.23-.918-.47-1.835-.71-2.753v-.177c-.21-.059-.42-.119-.62-.178-.45-.609-1.16-2.64-.81-3.551l.54-.444c.14-.331-.44-2.78-.27-3.728.48-2.731 1.74-4.831 3.75-6.037 4.59-2.747 11.36-.174 12.42 4.084.43 1.696.18 3.537.09 5.149-.03.541.4.619.54.976.58 1.557-.43 3.048-1.43 3.463-.07 3.092-1.84 4.394-1.88 7.368h.18c.9.355 1.79.71 2.68 1.066l.45 1.154 3.3 2.219c3.53 2.097 8.89 5.757 9.12 11.079z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.d1e7aa3f4a401fa221089fc227f71c1c.svg";
export { ForwardRef as ReactComponent };